<template>
<div  class="myChatBox clear-fix">
  <!--  头像-->
  <div class="img" @click="test">
    <img :src="getHeadImg" alt="">
  </div>

  <!--  对话-->
  <div class="chatBox">
    <div class="text">{{ text }} <span v-if="hasReplyName">@{{ replyName }}</span> </div>
  </div>

</div>
</template>

<script>
export default {
  name: "myChat",
  computed:{
    getHeadImg(){
      if(this.headImg!=''){
        return this.headImg
      }else{
        return require("../../../../assets/app/logo.png")
      }
    },
    hasReplyName(){
      if(this.replyName==null){
        return false
      }
      if(this.replyName!=''){
        return true
      }
      return false
    }
  },
  props:{
    headImg:{
      type: String,
      default: require("../../../../assets/app/logo.png")
    },
    name:{
      type: String,
      default: ''
    },
    text: {
      type: String,
      default: '...内容内容'
    },
    replyName: {
      type: String,
      default: ''
    }
  },
  methods:{
    test(){
      console.log("新:"+window.document.documentElement.scrollHeight)
    }
  }
}
</script>

<style scoped>
.myChatBox{
  position: relative;
  width: 100%;
  margin-top: 40px;
  /*background-color: #ff5777;*/
}
.img{
  float: right;
  width: 120px;
  height: 120px;
  /*background-color: #07c160;*/
  border-radius: 120px;
  border: none;
}
.img img{
  border-radius: 120px;
}

.chatBox{
  float: right;
  max-width: 580px;
  min-height: 100px;
  /*background-color: #0c83ae;*/
  padding-right: 28px;
  text-align: right;
  overflow-wrap: break-word;
}
.text{
  font-size: 42px;
  color: whitesmoke;
  background-color: #51b73d;
  border-radius: 6px;
  padding: 20px;
  line-height: 54px;
  text-align: left;
  margin-top: 18px;
}
.text span{
  color: #0054ff;
}
</style>